import { useEffect, useRef, useState } from 'react';
import type { MutableRefObject } from 'react';
import { WindowHelper } from '../utils/WindowHelper';

// anys are consumer-forced: FilterBar passes direction '' and feeds `breakpointValue && breakpointValue.x` into style props; the ref attaches to heterogeneous element types
export const useBreakpointRef = ({
  breakpoints,
  breakpointValues,
  direction,
}: {
  breakpoints: number | readonly number[];
  breakpointValues?: readonly any[];
  direction?: string;
}): { ref: MutableRefObject<any>; breakpointIndex: number; breakpointValue: any } => {
  const containerRef = useRef<any>(null);
  const [breakpointIndex, setBreakpointIndex] = useState(-1);

  const onBreakpointChange = (index: number) => {
    setBreakpointIndex(index);
  };

  useEffect(() => {
    // casts compile-time only: watchBreakpoints never mutates points and width-defaults non-'y' directions
    return WindowHelper.watchBreakpoints(
      breakpoints as number | number[],
      onBreakpointChange,
      direction as 'x' | 'y',
      containerRef.current
    );
  });

  return {
    ref: containerRef,
    breakpointIndex,
    breakpointValue: breakpointIndex > -1 && breakpointValues ? breakpointValues[breakpointIndex] : null,
  };
};
